export const resetRadioInputField = (inputRef: {
  current: { resetCheckedState: () => void } | null;
}) => {
  if (inputRef.current !== null) {
    const yes = document.getElementById("dynamic-yes")! as HTMLInputElement;
    const no = document.getElementById("dynamic-no")! as HTMLInputElement;
    if (yes.checked) {
      yes.checked = false;
      inputRef.current.resetCheckedState();
    } else if (no.checked) {
      no.checked = false;
      inputRef.current.resetCheckedState();
    }
  }
};
